// Fichier: src/components/PriceDisplay.js
import React from 'react';
import { Tag } from 'lucide-react';

const PriceDisplay = ({ price, categoryName, promotion, className = '' }) => {
  // Si pas de promotion, affichage normal
  if (!promotion || !promotion.hasPromotion) {
    return (
      <div className={`flex items-center gap-1 ${className}`}>
        <span className="font-bold text-purple-700">{price}</span>
      </div>
    );
  }

  // Avec promotion : prix barré + nouveau prix + badge
  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      {/* Ligne 1 : Prix barré et nouveau prix */}
      <div className="flex items-center gap-2 flex-wrap">
        {/* Prix barré */}
        <span className="text-gray-500 line-through text-xs">
          {promotion.originalPrice}
        </span>
        
        {/* Nouveau prix */}
        <span className="text-purple-700 font-bold">
          {promotion.discountedPrice}
        </span>
      </div>
      
      {/* Ligne 2 : Badge promotion */}
      <div>
        <span className="bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full inline-flex items-center gap-1">
          <Tag className="w-2.5 h-2.5" />
          -{promotion.discountPercent}%
        </span>
      </div>
    </div>
  );
};

export default PriceDisplay;